<div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-5 py-4 bg-talos-bg" style="border-top:1px solid rgb(var(--talos-ink-rgb) / 0.08)">
  <p class="text-xs" style="color:rgb(var(--talos-ink-rgb) / 0.5)">
    Showing
    <span class="font-semibold text-talos-ink">{{ startIndex() }}–{{ endIndex() }}</span>
    of
    <span class="font-semibold text-talos-ink">{{ totalCount() }}</span>
    results
  </p>
  <div class="flex items-center gap-2">
    <app-button
      variant="secondary"
      size="sm"
      label="Previous"
      [icon]="ChevronLeftIcon"
      iconPosition="left"
      [disabled]="currentPage() === 1"
      (clicked)="prev()" />
    <span class="text-[10px] font-bold uppercase tracking-[0.12em] px-1" style="color:rgb(var(--talos-ink-rgb) / 0.4)">Page {{ currentPage() }} of {{ totalPages() }}</span>
    <app-button
      variant="secondary"
      size="sm"
      label="Next"
      [icon]="ChevronRightIcon"
      iconPosition="right"
      [disabled]="currentPage() === totalPages()"
      (clicked)="next()" />
  </div>
</div>
